import axios from 'axios';
import Url from '../constants/Url';

class NewsApi {
    getNews(params?) {
        return axios
            .get(Url().GET_NEWS, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getNews:', ex.message);
                throw ex;
            });
    }

    getArticle({slug, ...params}) {
        return axios
            .get(Url().GET_ARTICLE(slug), {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getArticle:', ex.message);
                throw ex;
            });
    }
}

export default new NewsApi();
